import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import {
    ViewModelForm,
    ViewModelServiceContext
} from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import _TWIADateUtil from '../../../../modules/twia-portals-viewmodel-js/aspects/_TWIADateUtil';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { CancellationService, PolicyService } from 'gw-capability-gateway';
import { TWIADocumentUtil } from 'gw-capability-document-react';
import { Loader, useModal } from '@jutro/components';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext, useCallback, useMemo } from 'react';
import DocumentUploadComponent from '../../components/DocumentUpload/DocumentUploadComponent';
import messages from './Cancellation.messages';
import metadata from './Cancellation.metadata.json5';
import styles from './Cancellation.module.scss';

function Cancellation(props) {
    const { onDoNotCancel, policyNumber, policyData, history, authHeader, showErrors, onValidate, isInvalid } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        isComponentValid,
        onValidate: setComponentValidation,
    } = useValidation('Cancellation');
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { authUserData } = useAuthentication();
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const [cancellationSubmissionVM, setCancellationSubmissionVM] = useState({});
    const [enableRefundMethod, setEnableRefundMethod] = useState(true);
    const [enableEffectiveDate, setEnableEffectiveDate] = useState(true);
    const [startCancellationTag, setStartCancellationTag] = useState(false);
    const [validationErrorMessage, setValidationErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);
    const [ sourceVal, selectedSourceVal ] = useState();
    const [ reasonVal, selectedReasonVal ] = useState();
    const [ refundMethod, selectedRefundMethod ] = useState();
    const [ selectedEffectiveDate, setSelectedEffectiveDate ] = useState();
    const { showAlert } = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const [ reasonAvailVal, setReasonAvailVal] = useState();
    const [ textVal, setTextVal ] = useState();
    const [cancellationStarted, setCancellationStarted ] = useState({});
    const policyEffectiveDate = new Date(
        _.get(policyData, 'latestPeriod.effectiveDate')
    );
    const product = _.get(policyData, 'product.productCode');
    const [dateMismatchValidationMessage, setDateMismatchValidationMessage] = useState([]);
    const [selectedDocs, setSelectedDocs] = useState([]);
    const documentTypeCodes = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.DocumentType').codes;
    const formattedCommonDocTypeCodes = documentTypeCodes?.map(code => ({
        code: code.code,
        name: translator({ id: code.name })
    }));
    const documentFilterType = TWIADocumentUtil.getPolicyDocumentTypeFilterName(product);
    const allowedDocumentTypes = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.DocumentType').getFilter(documentFilterType).codes;
    const docTypeValues = allowedDocumentTypes && allowedDocumentTypes.flatMap(docType => {
        if (docType.code === 'cancellation_doc_ext') {
            return {
                code: docType.code,
                name: translator({
                    id: docType.name,
                    defaultMessage: docType.name,
                }),
            };
        }
        return [];
    });

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'Cancellation');
        }
    }, [isComponentValid, onValidate]);

    // useEffect(() => {
    //     isInvalid(isComponentValid, 'Cancellation');
    // }, [isInvalid, isComponentValid])

    useEffect(() => {
        const model = {};
        const vm = createVM(model);

        _.set(vm, 'actualExpirationDate', _.get(policyData, 'latestPeriod.expirationDate'));
        setCancellationSubmissionVM(vm);
        setStartCancellationTag(true);
    }, []);

    const isCancelReasonInsuredsRequestTwia = useCallback(() =>  {
        const val = _.get(cancellationSubmissionVM, 'cancelReasonCode.value.code');

        return val === 'noc';
    });

    const isSourceInsuredTwia = useCallback(() => cancellationSubmissionVM.cancellationSource.value.code === 'insured');

    const sourceChanged = useCallback(() => { // DE17081 & DE17079
        setStartCancellationTag(true);

        const code = isSourceInsuredTwia()
            ? cancellationSubmissionVM.cancelReasonCodeInsured_TWIA
            : cancellationSubmissionVM.cancelReasonCodeMortgagee_TWIA;

        if (code && product !== 'CommercialProperty') {
            const availVal = code.aspects.availableValues
                .filter(code => code.code !== 'nottaken_twia' && code.code !== 'nottaken') // DE17099
                .map((code) => ({
                    code: code.code,
                    name: translator({ id: code.name })
                }));

            setReasonAvailVal(availVal);
        } else if (isSourceInsuredTwia() && product === 'CommercialProperty'){
            const availVal = cancellationSubmissionVM.cancelReasonCode.aspects.availableValues
            .filter(code => code.code !== 'nottaken_twia' && code.code !== 'nottaken' && code.code !== 'foreclosure_Ext') // DE18588
            .map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
              }));

              setReasonAvailVal(availVal);
        } else {
            const availVal = cancellationSubmissionVM.cancelReasonCode.aspects.availableValues
            .filter(code => code.code !== 'nottaken_twia' && code.code !== 'nottaken') // DE17099
            .map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
              }));

              setReasonAvailVal(availVal);
        }
    });

    const validateEffectiveDate = useCallback(() => {
        const selectedEffectiveDate = _.get(cancellationSubmissionVM, 'effectiveDate.value');
        const cancellation = _.cloneDeep(policyData);
        
        const latestPeriodExpiryDate = moment(cancellation.latestPeriod.expirationDate);
        const chosenEffectiveDate = moment(selectedEffectiveDate);
        const latestPeriodEffectiveDate = moment(cancellation.latestPeriod.effectiveDate);

        if (isCancelReasonInsuredsRequestTwia()) {
            const currentDate = moment();

            if (chosenEffectiveDate.isBefore(currentDate, 'day')) {
                setStartCancellationTag(true);
                setShowError(true);
                setValidationErrorMessage(translator(messages.selectInsuredDate));

                return;
            }

            if(chosenEffectiveDate.isBefore(latestPeriodEffectiveDate, 'day')){
                setValidationErrorMessage(translator(messages.selectAfterDate));
                setStartCancellationTag(true);
                setShowError(true);

                return;
            }

            if (chosenEffectiveDate.isSameOrAfter(latestPeriodExpiryDate, 'day')) {
                setStartCancellationTag(true);
                setShowError(true);
                setValidationErrorMessage(translator(messages.selectBeforeDate));

                return;
            }
        } else {
            if (chosenEffectiveDate.isBefore(latestPeriodEffectiveDate, 'day')) {
                setStartCancellationTag(true);
                setShowError(true);
                setValidationErrorMessage(translator(messages.selectAfterDate));

                return;
            }

            if (chosenEffectiveDate.isSameOrAfter(latestPeriodExpiryDate, 'day')) {
                setStartCancellationTag(true);
                setShowError(true);
                setValidationErrorMessage(translator(messages.selectBeforeDate));

                return;
            }
        }
        if (!_.isUndefined(selectedEffectiveDate)) {
            setStartCancellationTag(false);
        }
        setValidationErrorMessage('');
        setShowError(false);
    },[cancellationSubmissionVM, isCancelReasonInsuredsRequestTwia, policyData, translator]);

    const retrieveRefundMethodAndCancellationEffectiveDateTwia = useCallback(async (path) => {
        setIsLoading(true);

        let cancellationPromise;
        const dataTo = {
            cancellationSource:  _.get(cancellationSubmissionVM, 'cancellationSource.value.code'),
            isTempCancellation: true,
            cancelReasonCode: _.get(cancellationSubmissionVM, 'cancelReasonCode.value.code'),
            effectiveDate: _.get(cancellationSubmissionVM, 'effectiveDate.value') || _TWIADateUtil.dateToLocalDate(new Date())  // DE19754
        };
           
        await CancellationService.getValidRefundMethodAndEffectiveCancellationDate_TWIA(policyNumber, dataTo, authHeader).then(response => {
            setEnableRefundMethod(true);

            const effectiveDate = new Date(response.cancellationEffectiveDate);
            const effectiveDateObject = {
                day: effectiveDate.getUTCDate(),
                month: effectiveDate.getUTCMonth(),
                year: effectiveDate.getUTCFullYear()
            };
            const policyEffectiveObj = {
                day: policyEffectiveDate.getUTCDate(),
                month: policyEffectiveDate.getUTCMonth(),
                year: policyEffectiveDate.getUTCFullYear()
            };
           
            setEnableEffectiveDate(false);
            setShowError(false);
            cancellationPromise = response;
            _.set(cancellationSubmissionVM, 'cancellationRefundMethod', response.refundMethods[0]);
            setCancellationSubmissionVM(cancellationSubmissionVM);
            selectedRefundMethod(response.refundMethods[0]);
   
            const effDate = _.get(cancellationSubmissionVM, 'effectiveDate.value');

            if(!_.isUndefined(effDate) && path === 'effectiveDate'){
                _.set(cancellationSubmissionVM, 'effectiveDate', effDate);
                setSelectedEffectiveDate(effDate);
            } else {
                _.set(cancellationSubmissionVM, 'effectiveDate', effectiveDateObject);
                setSelectedEffectiveDate(effectiveDateObject);
            }

            setCancellationSubmissionVM(cancellationSubmissionVM);
            
            /** DE19635 - use refund method supplied by PC  */
            // reCalculateRefundMethodTwia();

            const getEffDate = LocalDateUtil.toMidnightDate(_.get(cancellationSubmissionVM, 'effectiveDate.value'));

            if(policyData.latestPeriod.displayStatus === 'Scheduled' && moment(getEffDate).isBefore(moment(policyEffectiveObj))){   // DE17075
                setStartCancellationTag(true);
                setShowError(true);
                validateEffectiveDate();
                return;
            } 
            else if(path === 'cancelReasonCode') {
                setStartCancellationTag(false);
                return;
            }
        });
        setIsLoading(false);
        
        return cancellationPromise;
    },[authHeader, cancellationSubmissionVM, policyData.latestPeriod.displayStatus, policyEffectiveDate, policyNumber, translator]);

    /**
     * DE19635: 
     * Corrected bug where desired cancellation date was not being sent
     * Use the refund method supplied by PC
     * @deprecated
     */
    const reCalculateRefundMethodTwia = useCallback(() => {
        const selectedEffectiveDate = _.get(cancellationSubmissionVM, 'effectiveDate.value');
        const issueDate = moment(policyEffectiveDate);
        const cancellationDate = moment(selectedEffectiveDate);
        const isSame = issueDate.isSame(cancellationDate, 'day');

        if (isSame) {
            const newRefundMethod = 'flat';

            selectedRefundMethod(newRefundMethod);
             _.set(cancellationSubmissionVM, 'cancellationRefundMethod', newRefundMethod);
            setCancellationSubmissionVM(cancellationSubmissionVM);
        }
    },[cancellationSubmissionVM, selectedRefundMethod]);

    const writeValue = useCallback((value, path) => {
        setDateMismatchValidationMessage([]);
        setValidationErrorMessage('');
        _.set(cancellationSubmissionVM, path, value);
        setCancellationSubmissionVM(cancellationSubmissionVM);

        if( path === 'cancellationSource') {
            selectedSourceVal(value);
            sourceChanged();         
        }

        if (path === 'cancelReasonCode') {
            selectedReasonVal(value);
            /**
             * DE19635 - reset eff. date on VM when 'cancelReasonCode' changes
             * and trigger validation
             */
            _.set(cancellationSubmissionVM, 'effectiveDate', _TWIADateUtil.dateToLocalDate(new Date()));
            validateEffectiveDate();
            retrieveRefundMethodAndCancellationEffectiveDateTwia(path);
        }

        if (path === 'effectiveDate') {
            setSelectedEffectiveDate(value);
            if (_.isUndefined(value)) {
                setDateMismatchValidationMessage([translator(messages.dateMustmatch)]);
                setStartCancellationTag(true);
                setShowError(true);

                return;
            }
 
            validateEffectiveDate();
            retrieveRefundMethodAndCancellationEffectiveDateTwia(path);
        }

        if (path === 'cancellationTextArea') {
            setTextVal(value);
        }
        
    },[cancellationSubmissionVM, translator]);

    const getAvailableSourceCode = useMemo(() => {
        const codeAvail = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.CancellationSource').codes
            .filter(code => code.code !== 'carrier') // Exclude the insurer code
            .map((code) => ({
                    code: code.code,
                    name: translator({ id: code.name })
                }));

        return codeAvail;
    }, [translator, viewModelService]);
    
    const createVM = (model) => {
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.gateway.job.cancellation.dto.CancellationDTO'
        );
    };

    const onStartCancel = async() => {
        validateEffectiveDate();

        const effectiveDateString = _.get(cancellationSubmissionVM, 'effectiveDate.value');
    
        const dataTo = {
            cancellationSource: _.get(cancellationSubmissionVM, 'cancellationSource.value.code'),
            isTempCancellation: true,
            cancelReasonCode: _.get(cancellationSubmissionVM, 'cancelReasonCode.value.code'),
            cancellationRefundMethod: _.get(cancellationSubmissionVM, 'cancellationRefundMethod.value.code'),
            description: _.get(cancellationSubmissionVM, 'cancellationTextArea'),
            effectiveDate: effectiveDateString
        };

        if(isComponentValid && !startCancellationTag) {
            setIsLoading(true);  // DE18597

            let effectiveDateResponse;

            const response = await PolicyService.createNewPolicyCancellationTransaction(
                policyNumber,
                dataTo,
                authHeader
            ).then(res => {
                effectiveDateResponse = res;
                _.set(cancellationSubmissionVM, 'cancellationNumber', res.jobNumber);
                setCancellationSubmissionVM(cancellationSubmissionVM);
                setCancellationStarted({ isStarted: true, jobNumber: res.jobNumber, effectiveDateResponse });
                if(isTFPA) {
                    history.push(`/cancellation/${effectiveDateResponse.jobNumber}/summary`, effectiveDateResponse);
                }
            }).catch(err => {       // DE17159
                const errorMessage = _.split(err.baseError, 'ErrorMessage: ')[1];

                if(errorMessage){
                    showAlert({
                        title: 'Error',
                        message: errorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: translator(messages.close)
                    })
                } else {
                    showAlert({
                        title: 'Error',
                        message: translator(messages.unableToCancel),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: translator(messages.close)
                    })
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
            
        } else {
            setStartCancellationTag(false);
        }
        
    };

    const handleDoNotCancel = () => {
        if (onDoNotCancel) {
            onDoNotCancel();
        }
    };

    const displayRefundValues = useMemo(() => {
        const codeAvail = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.CalculationMethod').codes
            .map((code) => ({
                    code: code.code,
                    name: translator({ id: code.name })
                }));

        return codeAvail;
    },[translator, viewModelService]);

    const isStartCancellationDisabled = () => {
        if(isCancelReasonInsuredsRequestTwia() || isTFPA) {
            return false;
        }
        return selectedDocs?.length === 0;
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    
    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        sourceId: {
            availableValues: getAvailableSourceCode,
            value: sourceVal
        },
        reasonId:{
            visible: !_.isEmpty(sourceVal),
            value: reasonVal,
            availableValues: reasonAvailVal
        },
        refundMethodId: {
            disabled: enableRefundMethod,
            availableValues: displayRefundValues, 
            defaultValue: refundMethod
        },
        effectiveDateId: {
            disabled: enableEffectiveDate,
            className: showError && styles.cancellationMessage,
            value: selectedEffectiveDate,
            defaultValue: _.get(cancellationSubmissionVM, 'effectiveDate'),
            validationMessages: dateMismatchValidationMessage
        },
        cancellationTextArea: {
            value: textVal
        },
        infoNotification: {
            message: isTFPA ? (
                <div>
                    {translator(messages.cancellationMessageTFPA)}
                </div>
            ) : (
                <div className={styles.infoNotificationMsg}>
                    <ul>
                        <li>{translator(messages.cancellationMessageOne)}</li>
                        <li>{translator(messages.cancellationMessageTwo)}</li>
                        <li>{translator(messages.cancellationMessageThree)}</li>
                    </ul>
                </div>
            ),
        },
        startCancel: {
            disabled: startCancellationTag || isStartCancellationDisabled()
        },
        errorMessageEffectiveDate: {
            content: validationErrorMessage
        },
        uploadDocumentsDetails: {
            visible: !isTFPA,
            policyNumber,
            productCode: product,
            cancellationStarted,
            history,
            selectedDocs,
            setSelectedDocs,
            docTypeValues,
            formattedCommonDocTypeCodes,
            defaultDocType: 'cancellation_doc_ext',
            setParentLoading: setIsLoading
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onStartCancel,
            onDoNotCancel: handleDoNotCancel,
            validateEffectiveDate,
        },
        resolveComponentMap: {
            documentUploadComponent: DocumentUploadComponent,
        }
    };


    return (
        <Loader loaded={!isLoading}>
            <ViewModelForm
            uiProps={metadata.pageContent}
            model={cancellationSubmissionVM}
            onValueChange={writeValue}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
            />
        </Loader>
    );
}

;

Cancellation.propTypes = {
    onDoNotCancel: PropTypes.func.isRequired,
    policyNumber: PropTypes.string.isRequired,
    policyData: PropTypes.shape({
        policyNumber: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string,
    }).isRequired,
};

export default Cancellation;
